import { render, staticRenderFns } from "./alldel.vue?vue&type=template&id=4cf6ad0c&"
import script from "./alldel.vue?vue&type=script&lang=js&"
export * from "./alldel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports